<template>
  <v-container>
    <v-btn color="primary" text class="text-h5 mt-10" @click="goBack()">
      <v-icon left>mdi-arrow-left</v-icon>
      {{ $t("common.back") }}
    </v-btn>
    <v-row class="text-h2 justify-center pa-10">
      {{ $t(`source.${update ? "update" : add ? "add" : "show"}.title`) }}
    </v-row>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="validate"
      :readonly="show"
    >
      <v-row class="justify-center">
        <v-col cols="12" sm="6" class="justify-end">
          <v-text-field
            v-model="source.title"
            :rules="[(v) => !!v || $t('source.form.error.title')]"
            :label="$t('source.form.label.title')"
            required
          ></v-text-field>
          <v-text-field
            v-model="source.author"
            :label="$t('source.form.label.author')"
            required
          ></v-text-field>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="
                  source.publicationYear !== ''
                    ? $d(new Date(source.publicationYear))
                    : ''
                "
                :label="$t('source.form.label.publicationYear')"
                prepend-icon="mdi-calendar"
                readonly
                :v-bind="show ? null : attrs"
                v-on="show ? null : on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="source.publicationYear"
              scrollable
              @input="menu = false"
            >
            </v-date-picker>
          </v-menu>
          <v-select
            :items="sourceTypes"
            v-model="source.type"
            :label="$t('source.form.label.sourceType')"
            :rules="[(v) => !!v || $t('source.form.error.sourceType')]"
            return-object
            :append-icon="!show ? 'mdi-menu-down' : ''"
          >
            <template v-slot:item="{ item }">
              {{ $t(`source.form.enum.${item}`) }}
            </template>
            <template v-slot:selection="{ item }">
              {{ $t(`source.form.enum.${item}`) }}
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-form>
    <DataListMoleculeComponent v-if="!this.add"></DataListMoleculeComponent>
    <v-row class="justify-center">
      <v-btn
        v-if="!show"
        :disabled="!valid"
        color="success"
        class="ma-4"
        @click="validate"
      >
        {{ $t(`source.button.${update ? "update" : "add"}`) }}
      </v-btn>
      <v-btn
        v-if="this.update"
        :disabled="!valid"
        color="error"
        class="ma-4"
        @click="deleteItem"
      >
        {{ $t(`source.button.delete`) }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import router from "@/router";
import Vue, { ref } from "vue";
import { storeToRefs } from "pinia";
import { useSourceStore } from "@/store/sourceStore";
import i18n from "@/i18n";
import { POSITION, TYPE } from "vue-toastification";
import { useUserStore } from "@/store/userStore";
import { useMoleculeStore } from "@/store/moleculeStore";
import DataListMoleculeComponent from "@/components/molecule/DataListMoleculeComponent.vue";

export default {
  components: { DataListMoleculeComponent },
  data: () => ({
    menu: false,
    valid: true,
    store: useSourceStore(),
    userStore: useUserStore(),
    moleculeStore: useMoleculeStore(),
    source: ref(null),
    sourceTypes: ref([]),
  }),
  props: {
    add: Boolean,
    update: Boolean,
    show: Boolean,
  },
  async beforeMount() {
    if ((this.update || this.add) && !this.userStore.isWriter()) {
      Vue.$toast(i18n.t("source.toast.access.error"), {
        timeout: 2000,
        position: POSITION.TOP_CENTER,
        type: TYPE.ERROR,
      });
      this.goBack();
      return;
    }
    this.source = storeToRefs(this.store).source;
    this.sourceTypes = storeToRefs(this.store).sourceTypes;
    this.store.getSourceTypes();
    if (!this.add) {
      await this.store.getSourceById(parseInt(router.currentRoute.params.id));
      this.moleculeStore.molecules = this.source.molecules;
    }
  },
  methods: {
    validate() {
      if (!this.show && this.$refs.form.validate()) {
        if (this.update) {
          this.store.updateSource().then(() => this.goBack());
        } else {
          this.store.addSource().then(() => this.goBack());
        }
      }
    },
    goBack: function () {
      this.store.$reset();
      this.moleculeStore.$reset();
      router.go(-1);
    },
    deleteItem() {
      if (confirm(this.$t("source.delete.confirm"))) {
        this.store.deleteSource(this.source.id);
        this.goBack();
      }
    },
  },
};
</script>
